import React from "react";
import './Policies.css'
import useMeta from '../../../hooks/useMeta'

import { Link } from "react-router-dom";

import Navbar from "../../../CommonComponent/Navbar/Navbar";
import NotificationBar from "../../../CommonComponent/Notification/NotificationBar";
import Footer from "../../../CommonComponent/Footer/footer";

const Policies = () => {

    useMeta({
        title: 'Policies | Marvel Blinds',
        description: null,
        canonical: `${process.env.REACT_APP_WEBSITE_URL}/policies`,
        og: {
            locale: 'en_US',
            type: 'article',
            title: 'Policies',
            description:
                null,
            url: `${process.env.REACT_APP_WEBSITE_URL}/policies`,
            site_name: 'Marvel Blinds',
        },
    });

    return (
        <>
            <Navbar />
            <NotificationBar />
            <div className="policies-pg-container">
                <h2 className="policies-pg-title">POLICIES</h2>
                <table className="policies-pg-content-table">
                    <tbody>
                        <tr>
                            <td className="even-row">
                                <Link target="_blank" to="/Documnets/POLICY-FOR-DISCLOSURE-OF-MATERIAL-EVENTS-OR-INFORMATION-AND-DISCLOSURE.pdf">
                                    Policy for disclosure of material events or information and disclosure
                                </Link>
                            </td>
                        </tr>
                        <tr>
                            <td className="Border-none">
                                <Link target="_blank" to="/Documnets/code_of_practices_and_procedures_for_fair.pdf">
                                    Code of Practices and Procedures for Fair Disclosure of UPSI wef 01042019
                                </Link>
                            </td>
                        </tr>
                        <tr>
                            <td className="even-row">
                                <Link target="_blank" to="/Documnets/dividende_distribution_policy.pdf">
                                    Dividende Distribution Policy
                                </Link>
                            </td>
                        </tr>
                        <tr>
                            <td className="Border-none">
                                <Link target="_blank" to="/Documnets/insider_trading_policy.pdf">
                                    Insider Trading Policy
                                </Link>
                            </td>
                        </tr>
                        <tr>
                            <td className="even-row">
                                <Link target="_blank" to="/Documnets/material_subsidiaries_policy.pdf">
                                    Material Subsidiaries Policy
                                </Link>
                            </td>
                        </tr>
                        <tr>
                            <td className="Border-none">
                                <Link target="_blank" to="/Documnets/policy_on_-board_diversity.pdf">
                                    Policy on Board Diversity
                                </Link>
                            </td>
                        </tr>
                        <tr>
                            <td className="even-row">
                                <Link target="_blank" to="/Documnets/policy_on_evaluation_of_performance_of_directors_and_the_board.pdf">
                                    Policy on Evaluation of Performance of Directors and the Board
                                </Link>
                            </td>
                        </tr>
                        <tr>
                            <td className="Border-none">
                                <Link target="_blank" to="/Documnets/Change_RPT_Policy.pdf">
                                    Policy on Related Party Transactions
                                </Link>
                            </td>
                        </tr>
                        <tr>
                            <td className="even-row">
                                <Link target="_blank" to="/Documnets/remuneration_policy_for_non_executive_director.pdf">
                                    Remuneration Policy for Non Executive Director
                                </Link>
                            </td>
                        </tr>
                        <tr>
                            <td className="Border-none">
                                <Link target="_blank" to="/Documnets/sexual_harassment_prevention_policy.pdf">
                                    Sexual Harassment Prevention Policy
                                </Link>
                            </td>
                        </tr>
                        <tr>
                            <td className="even-row">
                                <Link target="_blank" to="/Documnets/Terms and Conditions of Appointment of Independent Directors.pdf">
                                    Terms and Conditions of Appointment of Independent Directors
                                </Link>
                            </td>
                        </tr>
                        <tr>
                            <td className="Border-none">
                                <Link target="_blank" to="/Documnets/Vigil-Mechanism_Whistle-Blower-Policy.pdf">
                                    Vigil Mechanism_Whistle Blower Policy
                                </Link>
                            </td>
                        </tr>
                        <tr>
                            <td className="even-row">
                                <Link target="_blank" to="/Documnets/familiarization_programme_for_director.pdf">
                                    Familiarization Programme for Director
                                </Link>
                            </td>
                        </tr>
                        <tr>
                            <td className="Border-none">
                                <Link target="_blank" to="/Documnets/csr_policy_marvel.pdf">
                                    CSR Policy
                                </Link>
                            </td>
                        </tr>
                        <tr>
                            <td className="even-row">
                                <Link target="_blank" to="/Documnets/policy_for_preservation_of_documents.pdf">
                                    Policy for Preservation of Documents
                                </Link>
                            </td>
                        </tr>
                        <tr>
                            <td className="Border-none">
                                <Link target="_blank" to="/Documnets/nomination_and_remuneration_policy.pdf">
                                    Nomination and Remuneration Policy
                                </Link>
                            </td>
                        </tr>
                        <tr>
                            <td className="even-row">
                                <Link target="_blank" to="/Documnets/policy_on_web_archival.pdf">
                                    Policy on Web Archival of Information Disclosed to Stock Exchanges
                                </Link>
                            </td>
                        </tr>
                        <tr>
                            <td className="border-top-none">
                                <Link target="_blank" to="/Documnets/code_of_conduct_board_directors.pdf">
                                    Code of Conduct for Board of Directors and Senior Managerial Personnel
                                </Link>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <table className="policies-pg-table-2">
                    <tbody>
                        <tr>
                            <th className="even-row">
                                Contact details of person authorized to determine materiality of event or information and making disclosures to stock exchange(s)
                            </th>
                            <td className="even-row">
                                Mr. Ashok Ramniklal Paun, Chairman & Managing Director <br />
                                Plot No. 211, GIDC Phase II, Dared, Jamnagar, Gujarat - 361004. <br />
                                Contact No.: 0288 2730601 <br />
                                Email Id: ashok@marvellifestyle.com
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <Footer />
        </>
    );
}

export default Policies;